import { getWSGFirmIds } from "../Services/Firm";
import { fetchPersonByFirmIds } from "../Services/Person";

export interface StaffContactOption {
  id: string;
  name: string;
  email: string;
}

function mapPersonToStaffContact(
  person: Record<string, unknown>,
): StaffContactOption | null {
  const id = String(person.id ?? "").trim();
  if (!id || person.isDeleted) {
    return null;
  }

  const email = String(person.firmEmail ?? person.email ?? "").trim();
  if (!email) {
    return null;
  }

  const name =
    [person.name, person.middleInitial, person.lastName]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim() || "Unknown";

  return { id, name, email };
}

/** WSG staff contacts (same source as Events staff picker). */
export async function fetchStaffContactOptions(): Promise<StaffContactOption[]> {
  const wsgFirmIds = await getWSGFirmIds();
  if (!wsgFirmIds.length) {
    return [];
  }

  const people = await fetchPersonByFirmIds(wsgFirmIds);
  return (people || [])
    .map((person: Record<string, unknown>) => mapPersonToStaffContact(person))
    .filter((option): option is StaffContactOption => option !== null)
    .sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
    );
}
